import { FC } from "react";
import {
  CustomerActivity,
  CustomerActivityAction,
  CustomerActivityDataWithType,
  CustomerActivityRendererProps,
} from "./types";
import CustomerAddActivity from "./customer-add-activity";
import CustomerDeleteActivity from "./customer-delete-activity";
import CustomerEditActivity from "./customer-edit-activity";
import Container, { EmptyContainer } from "../../meta-container";

const CustomerActivityRenderer: FC<CustomerActivityRendererProps> = ({
  activity,
  type,
  by,
  date,
}) => {
  const _activity = activity as CustomerActivity;
  return (
    <Container<CustomerActivityAction, CustomerActivityDataWithType>
      data={{ type, activity: _activity.data, by, date }}
      type={_activity.action}
      match={{
        [CustomerActivityAction.None]: EmptyContainer,
        [CustomerActivityAction.Add]: CustomerAddActivity,
        [CustomerActivityAction.Delete]: CustomerDeleteActivity,
        [CustomerActivityAction.Edit]: CustomerEditActivity,
      }}
    />
  );
};

export default CustomerActivityRenderer;
